import * as React from 'react';
import { Query } from 'react-apollo';

import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
// @ts-ignore
import CommunicationSettingsView from 'settings/components/CommunicationSettingsView';
import ErrorReporter from 'app/components/ErrorReporter';
import NOTIFICATION_SETTINGS_QUERY from 'settings/queries/NotificationSettingsQuery.gql';
import { NotificationSettingsQuery } from 'settings/queries/__generated__/NotificationSettingsQuery';

class CommunicationSettingsContainer extends React.Component<any> {
  render() {
    return (
      <Query<NotificationSettingsQuery> query={NOTIFICATION_SETTINGS_QUERY}>
        {({ loading, error, data }) => {
          if (loading) {
            return <CenteredLoadingIndicator />;
          }

          if (error || !data || !data.me) {
            return (
              <ErrorReporter error="CommunicationSettingsContainer - could not fetch user data" />
            );
          }

          const isTeacher = data.me.role === 'teacher';
          const showSmsDevices = data.me.sms_supported;
          const twoWayMessagingEnabled = data.me.preferences
            ? data.me.preferences.two_way_messaging
            : false;

          return (
            <CommunicationSettingsView
              showSmsDevices={showSmsDevices}
              isTeacher={isTeacher}
              twoWayMessagingEnabled={Boolean(twoWayMessagingEnabled)}
            />
          );
        }}
      </Query>
    );
  }
}

export default CommunicationSettingsContainer;
